module.exports = __webpack_public_path__ + "static/media/cs1.7abe9e66.jpeg";